// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wDjj","textarea":"styles_textarea__29sWa"};